<template>
    <div class="absolute-date-range">
        <pendo-date-picker
            class="absolute-date-range__first"
            is-required
            :append-to-body="false"
            :value="first"
            :max-date="last"
            :disabled="readOnly"
            :invalid="checkValidRule && !isFirstValid"
            :locale-code="$segmentFlag('localizationUI') ? $locale() : undefined"
            full-width
            @select-date="updateFirst" />
        <div class="absolute-date-range__and-label">
            {{ $t('and') }}
        </div>
        <pendo-date-picker
            class="absolute-date-range__last"
            is-required
            :append-to-body="false"
            :value="last"
            :disabled="readOnly"
            :min-date="first"
            :invalid="checkValidRule && !isLastValid"
            :locale-code="$segmentFlag('localizationUI') ? $locale() : undefined"
            full-width
            @select-date="updateLast" />
    </div>
</template>

<script>
import { PendoDatePicker } from '@pendo/components';
import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

export default {
    name: 'AbsoluteDateRange',
    components: {
        PendoDatePicker,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    computed: {
        first () {
            return moment(this.value.first, { ignoreTimeZone: true }).toDate();
        },
        last () {
            return moment(this.value.last, { ignoreTimeZone: true }).toDate();
        },
        isFirstValid () {
            return moment(this.value.first, DATE_FORMAT.iso, true, { ignoreTimeZone: true }).isValid();
        },
        isLastValid () {
            return moment(this.value.last, DATE_FORMAT.iso, true, { ignoreTimeZone: true }).isValid();
        },
    },
    created () {
        let first = moment(this.value.first, { ignoreTimeZone: true });
        let last = moment(this.value.last, { ignoreTimeZone: true });

        if (!this.isFirstValid) {
            first = moment(new Date(), { ignoreTimeZone: true }).subtract(1, 'days');
        }

        if (!this.isLastValid || last.isBefore(first)) {
            last = moment(first, { ignoreTimeZone: true }).add(1, 'days');
        }

        this.updateFirst({ value: first });
        this.updateLast({ value: last });
    },
    methods: {
        updateFirst (date) {
            const value = moment(date.value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
            this.$emit('input', { field: 'first', value });
        },
        updateLast (date) {
            const value = moment(date.value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
            this.$emit('input', { field: 'last', value });
        },
    },
};
</script>

<style scoped lang="less">
.absolute-date-range {
    align-items: center;
    grid-column: span 2;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
}

.absolute-date-range__and-label {
    color: var(--palette-gray-70);
    margin: 0px 8px;
}
</style>
